export const GetNavigations = (url) => {
    const isPublish = window.__E_TT_Client?.isPublish || false;

    if (isPublish) {
        return `/${window.__E_TT_Client.companySlug}${url}`;
    }
    return url;

}